import { AppCardSkeleton, AppCardSkeletonMetaFooter } from '@app/components/base/app-card';

/**
 * Skeleton placeholder matching CompositionCard layout: 16/9 media, title, footer meta.
 */
export function CompositionCardSkeleton() {
  return <AppCardSkeleton footer={<AppCardSkeletonMetaFooter />} />;
}
